module.exports = __webpack_public_path__ + "static/media/phone.a6dd0411.png";